import { EntitiesList } from '@/admin/billing/models/entities.enum';
import { CoreQuery } from '@/common/services/core-query';
import { httpClientCoreQuery } from '@/api/http-client';
import { AxiosPromise } from 'axios';
import { GetCardLinkEditResponse } from '@/admin/billing/models';

import {
    CardPersonaApiFactory,
    Currency,
    FrequencyInterval,
    PlanName,
    PlanSize,
} from '@eloomi/eloomi-billing-persona-client/1.0';
import { authorizeClient } from '@/api/http-client';

const cardClient = authorizeClient(CardPersonaApiFactory);

type GetCardLinkPayload = {
    returnUrl: string;
    plan: PlanName;
    size: PlanSize;
    frequency: FrequencyInterval;
    currency: Currency;
};

export function getCardLink(GetCardLinkPayload: GetCardLinkPayload) {
    return cardClient.getCards(
        GetCardLinkPayload.returnUrl,
        GetCardLinkPayload.plan,
        GetCardLinkPayload.size,
        GetCardLinkPayload.frequency,
        GetCardLinkPayload.currency
    );
}

export function getCardLinkEdit(returnUrl: string): AxiosPromise<GetCardLinkEditResponse> {
    const q = new CoreQuery()
        .path([
            EntitiesList.BILLING,
            EntitiesList.PERSONA,
            EntitiesList.ACCOUNT,
            EntitiesList.CARD,
            EntitiesList.LINK,
            EntitiesList.EDIT,
        ])
        .param({ return_url: returnUrl });
    return httpClientCoreQuery.get<GetCardLinkEditResponse>(q);
}

export function dibsStatus(payload): AxiosPromise<any> {
    const q = new CoreQuery().path([
        EntitiesList.BILLING,
        EntitiesList.PERSONA,
        EntitiesList.ACCOUNT,
        EntitiesList.CARD,
        EntitiesList.DIBS_STATUS,
    ]);
    return httpClientCoreQuery.post(q, payload);
}
